import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InvoiceApprovalInfo } from '../../../../types/InvoiceApprovalInfo';
import { ApprovalStatus } from '@lib/approval';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PersonModule } from '@lib/user';
import { BaseSiteLayoutModule, DayjsModule } from '@lib/util';
import { IimCardModule } from '@iim-angular/components';

@Component({
    selector: 'invoice-approver-overview-dialog',
    templateUrl: './invoice-approver-overview-dialog.component.html',
    styleUrls: ['./invoice-approver-overview-dialog.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule, PersonModule, BaseSiteLayoutModule, IimCardModule, DayjsModule],
})
export class InvoiceApproverOverviewDialogComponent {
    readonly approvalInfo = inject<InvoiceApprovalInfo>(MAT_DIALOG_DATA);
    private readonly dialogRef = inject<MatDialogRef<InvoiceApproverOverviewDialogComponent>>(MatDialogRef);


    public close() {
        this.dialogRef.close();
    }

    protected readonly ApprovalStatus = ApprovalStatus;
}
